<script>
import { mapState } from 'vuex'

export default {
  name: 'RcSiteContent',
  props: {
    contentClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    ...mapState({
      isMobileMenuVisible: state => state.root.isMobileMenuVisible,
    }),
  },
}
</script>

<template>
  <main
    id="skip-nav-target"
    class="rc-content-root"
    :class="contentClass"
    :aria-hidden="isMobileMenuVisible"
  >
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in" appear>
        <component :is="Component" />
      </transition>
    </router-view>
  </main>
</template>
